!function(){
  "use strict";

  if(!/^\/products\//.test(window.location.pathname)) return;

  var TEXT="Mindesthaltbar bis";
  var WERT="Je nach Charge: 2028/2029";

  function stil(){
    if(document.getElementById("mm-mhd-stil")) return;
    var s=document.createElement("style");
    s.id="mm-mhd-stil";
    s.textContent=[
      ".mmMhdZeile{display:flex;align-items:center;justify-content:space-between;gap:12px;",
      "margin:0 0 14px;padding:10px 12px;border:1px solid rgba(21,16,19,.14);",
      "border-radius:10px;background:rgba(243,233,236,.5);color:#151013;",
      "font-family:inherit;font-size:14px;line-height:1.35}",
      ".mmMhdZeile strong{font-weight:800;color:#151013}",
      ".mmMhdZeile span{color:rgba(21,16,19,.7);text-align:right}",
      "@media(max-width:480px){.mmMhdZeile{align-items:flex-start;flex-direction:column;gap:2px;",
      "padding:9px 10px;font-size:13px}.mmMhdZeile span{text-align:left}}"
    ].join("");
    (document.head||document.documentElement).appendChild(s);
  }

  function zeile(){
    var p=document.createElement("p");
    p.className="mmMhdZeile";
    p.setAttribute("data-mm-mhd","");
    var stark=document.createElement("strong");
    stark.textContent=TEXT;
    var wert=document.createElement("span");
    wert.textContent=WERT;
    p.appendChild(stark);
    p.appendChild(wert);
    return p;
  }

  function einfuegen(ziel){
    if(!ziel||ziel.querySelector("[data-mm-mhd]")) return false;
    var kopf=ziel.querySelector("h1,h2,h3,h4");
    if(kopf) kopf.insertAdjacentElement("afterend",zeile());
    else ziel.prepend(zeile());
    return true;
  }

  function akkordeons(){
    var erfolg=false;
    document.querySelectorAll('[class*="size-guide-tab-"]').forEach(function(tab){
      var titel=tab.querySelector('[class*="size-guide-question-"]');
      if(!titel||!/(zutaten\s+und\s+anwendung|produktangaben|produktinformationen)/i.test(titel.textContent||"")) return;
      var antwort=tab.querySelector('[class*="size-guide-answer-font-"]');
      var hoehe=tab.querySelector('[class*="size-guide-height-cal-font-"]');
      erfolg=einfuegen(antwort)||erfolg;
      erfolg=einfuegen(hoehe)||erfolg;
    });

    document.querySelectorAll("details").forEach(function(details){
      var summary=details.querySelector(":scope > summary");
      if(!summary||!/(produktangaben|produktinformationen)/i.test(summary.textContent||"")) return;
      var inhalt=details.querySelector('.mmPKinhalt,[class*="accordion__content"],[class*="details-content"],[class*="accordion-content"]');
      erfolg=einfuegen(inhalt)||erfolg;
    });
    return erfolg;
  }

  function starten(){
    stil();
    akkordeons();
    [250,800,1600,3000,6000].forEach(function(ms){window.setTimeout(akkordeons,ms)});
  }

  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",starten,{once:true});
  else starten();
  document.addEventListener("shopify:section:load",akkordeons);
}();
